import React, { useEffect, useRef, useState } from 'react'
import Card from '../../shared/card/Card'
import { ScrollView, View, Text, ActivityIndicator } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import CustomButton from '../../shared/button/Button'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import Canvas from '../../canvas'
import { useStoreStore } from '../../../stores/storeInfo'
import SignatureFormView from '../SignatureFormView'

const EEOInformationOnline = ({ navigation, route }) => {
    const {
        values,
        userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        ids,
    } = route.params

    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()

    const { postEEOOnline, loading } = useFormsStore()
    const { fetchData, storeData } = useStoreStore()

    useEffect(() => {
        fetchData(userId)
    }, [])




    const handlesubmit = async (signatureDataURL: any) => {
        const data = {
            completeOnline: true,
            essUserKey: intializestore?.initializeData?.userkey,
            entityId: personalstore?.personalData?.entityId,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            essObKey: essUserOnBoardingKey,
            sign: signatureDataURL,
            selectednum: Number(values?.ethnicity),

        }
        const response = await postEEOOnline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'Equal Employment Opportunity Form'}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('EEOInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
            />
        </>
    )
}
export default EEOInformationOnline
